const dev = false;
export default {
  // host: 'http://zk.qihe.live',
  host: dev ? 'http://zjy.qihe.local' : 'http://zjy.zj-qq.cn',
  appId: 'wx64bfdd034ba75e02',
  token: null,
  info: null,
  auth: false,
  mc: false, //是否必须完善资料
  dev
}
